import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

interface FooterProps {
  // You can add props here if needed
}

const Footer: React.FC<FooterProps> = () => {
const { t } = useTranslation();
const [open, setOpen] = useState(false);

  return (
    <footer className="footer">

      {/* TOP BAR */}
      <div className="footer-top">

        <div className="footer-title">
          <p>{t('footer.title')}</p>
        </div>

        <button
          className="footer-burger"
          onClick={() => setOpen(!open)}
        >
          {open ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>

      </div>

      {/* MENU */}
      <div className={`footer-menu ${open ? 'open' : ''}`}>

        <div className="footer-block">
          <ul>
            <li>
              <Link to="/rights" onClick={() => setOpen(false)}>
                {t('footer.bloc1.link2')}
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-block">
          <ul>
            <li>
              <Link to="/faq" onClick={() => setOpen(false)}>
                {t('footer.bloc2.link2')}
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-block">
          <ul>
            <li>
              <Link to="/contactForm" onClick={() => setOpen(false)}>
                {t('footer.bloc3.link1')}
              </Link>
            </li>
          </ul>
        </div>

      </div>

    </footer>
  );
};

export default Footer;